/**
 * @generated SignedSource<<13e92a718426ec0dd1b55758ffb115ce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type pageInfoFragment$data = {
  readonly endCursor: string | null | undefined;
  readonly hasNextPage: boolean;
  readonly hasPreviousPage: boolean;
  readonly startCursor: string | null | undefined;
  readonly " $fragmentType": "pageInfoFragment";
};
export type pageInfoFragment$key = {
  readonly " $data"?: pageInfoFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"pageInfoFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "pageInfoFragment",
  "selections": [
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startCursor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endCursor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasNextPage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasPreviousPage",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "PageInfo",
  "abstractKey": null
};

(node as any).hash = "ea27bf402586ed11b304569ab7c3f970";

export default node;
